import { DhofarSharedNavbarComponent } from 'dhofar-shared-pkg';
import { Component, inject, OnInit } from '@angular/core';
import { ConfigService } from 'core/services';
import { AuthenticationService } from 'core/services/auth/authentication.service';

@Component({
    selector: 'app-navbar',
    imports: [DhofarSharedNavbarComponent],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  nameAr: string;
  nameEn: string;
  isEnglish = true;
  configService = inject(ConfigService);
  authService = inject(AuthenticationService);

  constructor() {}

  ngOnInit(): void {
    // AUTHENTICATION DISABLED FOR TESTING - Set default values
    this.nameEn = 'Test User';
    this.nameAr = 'مستخدم تجريبي';

    // Original code - disabled for testing
    // this.authService.authNavStatus$.subscribe(res => {
    //   if (res) {
    //     this.nameAr = this.authService.User?.profile.EmployeeAr;
    //     this.nameEn = this.authService.User?.profile.EmployeeEn;
    //   }
    // });
  }

  navigateToPortal(): void {
    // this to fix the issue of replacing the permission of the current app to the redirected app
    sessionStorage.removeItem(this.configService.getAppUrl('OidcTicket'));
    window.location.href = this.configService.getAppUrl('PORTAL');
  }
  async logout() {
    await this.authService.signout();
  }
}
